import React, { Component, PropTypes } from 'react';
import groupBy from 'lodash/groupBy';
import ProjectLink from 'common/containers/project_link';
import Money from 'common/components/money';
import Feedback from 'common/containers/project_feedback';
import { getTimeLeftLabel } from 'common/utils';
import { getCategory } from 'common/ducks/categories';

export default class NewProjects extends Component {
  componentDidMount() {
    this.props.fetch();
  }

  render() {
    const { projects, categories } = this.props;

    if (projects.length === 0) {
      return <h4>No new projects at the moment</h4>;
    }

    const groupedByCategory = groupBy(projects, p => p.category);

    return (
      <div className="new-projects">
        { Object.keys(groupedByCategory).map(catId => {
          const category = getCategory(categories, parseInt(catId));

          return (
            <div key={catId}>
              <h4>{ category.name }</h4>
              <table className="table table-default">
                <thead>
                  <tr>
                    <td>Title</td>
                    <td>Time Left</td>
                    <td>Award</td>
                    <td>Entries</td>
                    <td>Feedback</td>
                  </tr>
                </thead>
                <tbody>
                  { groupedByCategory[catId].map(project => (
                  <tr key={project.id}>
                    <td><ProjectLink project={project} target="_blank" /></td>
                    <td>{ getTimeLeftLabel(project.deadline) }</td>
                    <td><Money value={project.total_awards_and_tips} showDecimals={false} /></td>
                    <td>{ project.entry_count }</td>
                    <td><Feedback project={project} /></td>
                  </tr>
                  )) }
                </tbody>
              </table>
            </div>
          );
        }) }
      </div>
    );
  }
}

NewProjects.propTypes = {
  fetch: PropTypes.func.isRequired,
  projects: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./project/components/new_projects.jsx